import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { functions, storage } from "../firebase";
import { UserFormData, StudentFormData } from "../utils/api/user/user.type";
import { httpsCallable } from "firebase/functions";
import { PaymentRequest } from "../utils/api/payment/payment.type";
import { AnswerFormData } from "../utils/api/support/support.type";
import { TeacherDashboardKPIs } from "../utils/api/dashboard/dashboard.type";

export const sendTeacherWelcomeEmail = async (email: string) => {
  const sendTeacherWelcomeEmail = httpsCallable(functions, 'sendTeacherWelcomeEmail');

  try {
    const response = await sendTeacherWelcomeEmail({ email });
    return response.data
  } catch (error) {
    throw error
  }
}

export const sendSchoolWelcomeEmail = async (email: string) => {
  const sendSchoolWelcomeEmail = httpsCallable(functions, "sendSchoolWelcomeEmail");

  const response = await sendSchoolWelcomeEmail({ email });
  return response.data;
}

export const handleReset = async (email: string) => {
  const sendReset = httpsCallable(functions, 'sendCustomPasswordReset');

  try {
    const result = await sendReset({ email });
    // alert("Consultez votre boîte mail !");
    console.log("result", result);
    return result.data
  } catch (error) {
    console.error("Erreur lors de l'envoi :", error);
    throw error;
  }
};

export const handleResendAccess = async ({ email, fullName }: { email: string; fullName: string }) => {
  const resendAccess = httpsCallable(functions, 'resendUserCredentials');

  try {
    const result = await resendAccess({
      email,
      fullName
    });
    return result.data
  } catch (error: any) {
    console.log("Erreur : " + error.message);
    throw error;
  }
};

export async function uploadFile(file: any, path: string | undefined) {
  const storageRef = ref(storage, path);

  // Téléchargement du fichier
  await uploadBytes(storageRef, file);

  // Obtenir l'URL du fichier
  const downloadURL = await getDownloadURL(storageRef);
  console.log("Fichier téléchargé.", downloadURL);
  return downloadURL;
}

export const addUser = async (data: UserFormData) => {
  const createUserByAdmin = httpsCallable(
    functions,
    "createUserByAdmin"
  );
  try {
    const result: any = await createUserByAdmin(data);
    return result.data;
  } catch (error: any) {
    console.log("Erreur lors de la vérification :", error);
    throw error;
  }
};

export const addStudentAndParent = async (data: StudentFormData) => {


  const createStudentAndParent = httpsCallable(
    functions,
    "createStudentAndParent"
  );
  try {
    const result: any = await createStudentAndParent(data);
    return result.data;
  } catch (error: any) {
    console.log("Erreur lors de la vérification :", error);
    throw error;
  }
};

export const importStudents = async (rows: Record<string, unknown>[]) => {
  const importStudentsFn = httpsCallable(functions, "importStudents");
  try {
    const result: any = await importStudentsFn({ rows });
    return result.data;
  } catch (error: any) {
    console.log("Erreur import élèves :", error);
    throw error;
  }
};

export const importTeachers = async (rows: Record<string, unknown>[]) => {
  const importTeachersFn = httpsCallable(functions, "importTeachers");
  try {
    const result: any = await importTeachersFn({ rows });
    return result.data;
  } catch (error: any) {
    console.log("Erreur import professeurs :", error);
    throw error;
  }
};

export const importClassrooms = async (rows: Record<string, unknown>[]) => {
  const importClassroomsFn = httpsCallable(functions, "importClassrooms");
  try {
    const result: any = await importClassroomsFn({ rows });
    return result.data;
  } catch (error: any) {
    console.log("Erreur import classes :", error);
    throw error;
  }
};

export const editStudentAndParent = async (targetUid: string, data: any) => {
  const editStudentAndParent = httpsCallable(
    functions,
    "updateStudentAndParent"
  )
  try {
    const result: any = await editStudentAndParent({ targetUid, userData: data });
    return result.data;
  } catch (error: any) {
    console.log("Erreur:", error);
    throw error;
  }
}

export const changeStudentTutor = async (data: {
  studentId: string;
  existingParentId?: string;
  newParent?: {
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    residence?: string;
    address?: string;
  };
}) => {
  const changeStudentTutor = httpsCallable(functions, "changeStudentTutor");
  try {
    const result: any = await changeStudentTutor(data);
    return result.data;
  } catch (error: any) {
    console.log("Erreur:", error);
    throw error;
  }
}

export const manageUser = async (
  userId: string,
  action: "block" | "delete" | "unblock"
) => {
  const manageUser = httpsCallable(functions, "manageUser");

  try {
    const response = await manageUser({ userId, action });
    return response.data;
  } catch (error: any) {
    return { error: error.message };
  }
};

export const editUserData = async (targetUid: string, data: any) => {
  const updateUserAccount = httpsCallable(
    functions,
    "updateUserAccount"
  )
  try {
    const result: any = await updateUserAccount({ targetUid, userData: data });
    return result.data;
  } catch (error: any) {
    console.log("Erreur :", error);
    throw error;
  }
}


export const createStripeCheckout = async (paymentData: PaymentRequest) => {
  const createStripeCheckout = httpsCallable<PaymentRequest>(
    functions,
    'createStripeCheckout'
  );
  try {
    const response = await createStripeCheckout(paymentData);
    return response.data;
  } catch (error: any) {
    return error;
  }
}

export const changeSubscriptionPlan = async (data: { newPlanId: string }) => {
  const changeSubscriptionPlan = httpsCallable(
    functions,
    'changeSubscriptionPlan'
  );
  try {
    const response = await changeSubscriptionPlan(data);
    return response.data;
  } catch (error: any) {
    return error;
  }
}

export const cancelSubscription = async () => {
  const cancelSubscription = httpsCallable(
    functions,
    'cancelSubscription'
  );
  try {
    const response = await cancelSubscription();
    return response.data;
  } catch (error: any) {
    return error;
  }
}

export const reactivateSubscription = async () => {
  const reactivateSubscription = httpsCallable(
    functions,
    'reactivateSubscription'
  );
  try {
    const response = await reactivateSubscription();
    return response.data;
  } catch (error: any) {
    return error;
  }
}

export const portalSession = async (returnUrl: string) => {
  const createPortalSession = httpsCallable(functions, "createPortalSession");
  try {
    const response = await createPortalSession({
      returnUrl
    });
    return response.data
  } catch (error: any) {
    return error
  }

}

export const handleRelanceUser = async ({ email, fullName, message, factureId }: { email: string; fullName: string; message: string; factureId: string }) => {
  const relanceUserFacture = httpsCallable(functions, 'relanceUserFacture');

  try {
    const result = await relanceUserFacture({
      email,
      fullName,
      message,
      factureId
    });
    return result.data
  } catch (error: any) {
    console.log("Erreur : " + error.message);
    throw error;
  }
};

export const handleNotifyAbsence = async (absenceId: string) => {
  const notifyAbsenceByEmail = httpsCallable(functions, 'notifyAbsenceByEmail');

  try {
    const result = await notifyAbsenceByEmail({ absenceId });
    return result.data;
  } catch (error: any) {
    console.log("Erreur : " + error.message);
    throw error;
  }
};

export const replyToSupportMessage = async (data: AnswerFormData) => {
  const replyToSupport = httpsCallable(functions, 'replyToSupportMessage');

  try {
    const response = await replyToSupport(data);
    return response.data;
  } catch (error: any) {
    throw error;
  }
}

export const sendBroadcastMessage = async (data: { messageText: string; targetType: "CLASS" | "SELECTION"; targetIds: string[]; messageType: string }) => {
  const sendBroadcastMessage = httpsCallable(functions, 'sendBroadcastMessage');

  try {
    const response = await sendBroadcastMessage(data);
    console.log('response msg', response)
    return response.data;
  } catch (error: any) {
    throw error;
  }
}

export const getTeacherDashboardKPIs = async (period: "week" | "month" | "year"): Promise<TeacherDashboardKPIs> => {
  const getTeacherDashboardKPIs = httpsCallable(functions, "getTeacherDashboardKPIs");

  try {
    const response = await getTeacherDashboardKPIs({ period })
    return response.data as TeacherDashboardKPIs
  } catch (error) {
    throw error
  }
}
